import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

export default function allowed() {
	const hasTodoList = hasSoftDeployAccess('TODO_LIST');
	return hasTodoList;
}
